import React from 'react';
import EventFilter from './EventFilter';
import EventCard from './EventCard';
import { v4 } from 'node-uuid';

const Events = (props) => {
  const {filter, eventsList, upcomingEventsList} = props.events;
  const events = filter === 'upcoming' ? upcomingEventsList : eventsList;

  return (
    <div>
      <EventFilter {...props} />
      {events.map((event) => <EventCard
        key={v4()}
        event={event}
      />)}
    </div>
  )
};


export default Events;



// WEBPACK FOOTER //
// ./src/components/Events/index.js